var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNonDetect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "27px",
    viewBox: "0 0 22 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B4E48779-9E6F-485E-945B-A2912C055342") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.4255069,0.546859903 C10.9926566,0.114009662 10.3433813,0.114009662 9.91053104,0.546859903 C9.58589336,0.871497585 0.928888533,9.74492754 0.928888533,15.3719807 C0.928888533,21.4318841 5.90666631,25.1111111 10.668019,25.1111111 C15.4293716,25.1111111 20.4071494,21.4318841 20.4071494,15.3719807 C20.4071494,9.74492754 11.7501446,0.871497585 11.4255069,0.546859903 Z",
    id: "path-1-non-detect"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GLOBAL---COMMUNICATIONS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communications---Dashboard---Basic",
    transform: "translate(-791.000000, -909.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Notification-Center",
    transform: "translate(204.000000, 582.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Program-Card---LCR",
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stat----Non-Detect",
    transform: "translate(574.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle-Icon---Translucent-Copy",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(13.333333, 11.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-non-detect",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-non-detect"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-\\uD83C\\uDFA8Color",
    mask: "url(#mask-2-non-detect)",
    fill: "#00B5E1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.000000, -6.000000)",
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 37.3333333,
    height: 37.3333333
  }))))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonDetect);
export default __webpack_public_path__ + "static/media/NonDetect.4a011469.svg";
export { ForwardRef as ReactComponent };